import React, { StatelessComponent } from 'react';
import b from 'b_';

import Rect from 'client/components/rect';

import './breadcrumbs.css';

const class_ = b.with('breadcrumbs');

const BreadcrumbsStub: StatelessComponent = () => {
    return (
        <div className={class_()}>
            <div className={class_('wrapper')}>
                <Rect className={class_('item')} width={50} height={16} />
                <Rect className={class_('item')} width={50} height={16} />
                <Rect className={class_('item')} width={250} height={16} />
            </div>
        </div>
    );
};

export default BreadcrumbsStub;
